import { render, staticRenderFns } from "./ciYuJiLei.vue?vue&type=template&id=6c8743f6&scoped=true&"
import script from "./ciYuJiLei.vue?vue&type=script&lang=js&"
export * from "./ciYuJiLei.vue?vue&type=script&lang=js&"
import style0 from "./ciYuJiLei.vue?vue&type=style&index=0&id=6c8743f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8743f6",
  null
  
)

export default component.exports